import { THEME } from "@app/utils/constants";

interface UserCookie {
  cointr_lang: string;
  cointr_unit: string;
  cointr_showasset: boolean;
  theme: string;
  cointr_valuationunit: number;
  cointr_layout: string;
}

const defaultCookie: UserCookie = {
  cointr_lang: "en",
  cointr_unit: "USD",
  cointr_showasset: false,
  theme: THEME.DARK,
  cointr_valuationunit: 1,
  cointr_layout: "right",
};

export const parseCookie = (cookieString?: string): UserCookie => {
  if (!cookieString) return defaultCookie;
  try {
    const uri = decodeURIComponent(cookieString);
    return JSON.parse(decodeURIComponent(uri));
  } catch (e) {
    return defaultCookie;
  }
};
